// For use in Node.js

var JSON2 = require('./json2');
var cycle = require('./cycle');

JSON2.decycle = cycle.decycle;
JSON2.retrocycle = cycle.retrocycle;

module.exports = JSON2;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/registry.npmmirror.com+JSON2@0.1.0_7c2a928d023ae98d5008ca7a71a1bf4f/~/JSON2/index.js
// module id = 9
// module chunks = 0